import axios from "axios";
import { API } from "../axios/API";

export const planesDePagoService = {
  getPlanes,
  getPlan,
  setEstado,
  simDataPlanPago
};

async function getPlan(data) {
  return data;
}

async function getPlanes(data) {
  try {
    let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/ppagoFiltro.php", {
      data: {
        bsq: 1,
        ...data
      }
    });


    return response.data;
  }
  catch (err) {
    console.log(err);
    return [];
  }
}

async function simDataPlanPago(data) {
  try {
    // rec: recurso de cuenta
    // imp: número de cuenta
    // cuotas: cuotas del plan de pago a calcular
    // plan: tipo de plan
    // anticipo: monto de cuota anticipo; optativo
    
    // jsdeuda* : json_array con siguientes campo:
    // ORIGEN: valor original
    // INTERES: valor intereses
    // ACTUAL: valor actualización
    // IVA: valor IVA calculado sobre ORIGEN (si corresponde)
    // MULTA: valor de multa sobre la cuota (si corresponde)
    // TOTAL: sumatoria de los 5 items anteriores
    // ANIO: año de la cuota origen (no puede ser 0)
    // NRO_PLAN: número de plan de pago a la que corresponde la cuota origen (debe ser 0)
    // CUOTA: número de cuota origen
    // FECHAVTO: fecha de vencimiento de cuota origen; formato aaaa-mm-dd

    let response = await API.post("/plandepago/simDataPlanPago", data);

    return response.data;
  }
  catch (err) {
    console.log(err);
    return [];
  }
}

async function setEstado(data) {
  try {
    let response = await API.post("/plandepago", data);

    return response?.data;
  }
  catch (err) {
    console.log(err);
    return [];
  }
}